import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { useLocation, useNavigate } from 'react-router'

//evertel
import { Col, Row } from '@evertel/web/ui'
import { useService } from '@evertel/di'
import { SessionService } from '@evertel/session/SessionService'
import { LoginService } from '@evertel/session/LoginService'
import { DrawerController } from '@evertel/message'
import { ThreadStore } from '@evertel/stores'
import { Step3SMSAuthentication } from './steps/Step3SMSAuthentication'


// Types
export interface RegistrationData {
    firstName: string
    lastName: string
    email: string
    password: string
    userId?: number
    isGovernmentEmail?: any
}

const RegistrationStepperAuthorized: React.FC = observer(() => {

    const sessionService = useService(SessionService)
    const loginService = useService(LoginService, [])
    const drawerController = useService(DrawerController, [])
    const threadStore = useService(ThreadStore)

    const navigate = useNavigate()
    const location = useLocation()

    const [registrationData, setRegistrationData] = useState<Partial<RegistrationData>>(location.state?.registrationData as Partial<RegistrationData> || {})

    useEffect(() => {
        if (sessionService.currentUserId) {
            // on web the drawer isn't loaded at this point so must fetch this here
            drawerController.fetchActiveThreads()
        }
    }, [sessionService.currentUserId])

    useEffect(() => {
        if (!registrationData.email || !registrationData.password) {
            // shouldn't navigate inside render phase

            // give it time to get botThread just in case
            setTimeout(handleFinishRegistration, 1000)
        }
    }, [])

    const handleFinishRegistration = () => {
        // Re-enable startup actions now that registration is complete.
        // Mirrors mobile RegistrationContinuationScreen pattern.
        loginService.setStartupActionsDisabled(false)

        const botThread = threadStore.findOne(t => t.isBotThread)

        if (botThread) {
            navigate(`/thread/${botThread.id}`)
        } else {
            navigate('/landing')
        }
    }

    if (!registrationData.email || !registrationData.password) {
        return null
    }

    return (
        <Row className="auth-layout animated">
            <Col
                valign="center"
                align="center"
                className="p-md-5 p-3"
                style={{ minHeight: '100vh', margin: 'auto', overflow: 'auto', maxWidth: 900 }}
            >
                <Step3SMSAuthentication
                    registrationData={registrationData as RegistrationData & Partial<{ parsedPhoneNumber: string }>}
                    onStepComplete={handleFinishRegistration}
                />
            </Col>
        </Row>
    )
})

export { RegistrationStepperAuthorized }
